
export interface UpgradePackDto
{
    getMsisdn(): string;
    getLanguage(): string;
    getToneId(): string;
    getToneName(): string;
    getPackName():string;
    getChannel(): string;
    getUserName(): string;
}

export class UpgradePackDtoImpl implements UpgradePackDto
{
    private msisdn: string;
    private language: string;
    private toneId: string;
    private toneName: string;
    private packName:string;
    private channel: string = "";
    private userName: string;

    getUserName(): string {
       return this.userName;
    }

    setUserName(userName: string)
    {
        this.userName = userName;
    }
    setChannel(channel: string)
    {
        this.channel = channel;
    }

    getChannel(): string {
       return this.channel;
    }

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getToneId(): string 
    {
        return this.toneId;
    }
    setToneId(toneId: string)
    {
        this.toneId = toneId;
    }

    getToneName(): string 
    {
        return this.toneName;
    }
    setToneName(toneName: string)
    {
        this.toneName = toneName;
    }

    getPackName():string
    {
        return this.packName;
    }

    setPackName(packName:string):void
    {
        this.packName = packName;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/upgradepack/upgradepackdto.tsx